import {StoreRepository} from '../repository/StoreRepository';
import {StoreStatistics} from '../models/store.model';

export class GetStoreStatisticsUseCase {
  constructor (private storeRepository: StoreRepository) {}

  async execute (): Promise<StoreStatistics> {
    try {
      return await this.storeRepository.getStatistics();
    } catch (error) {
      throw error;
    }
  }
}
